import Vue from 'vue';
import Router from 'vue-router';
// import appConstants from './config/constants';
import CamLayoutMediator from './views/CamLayoutMediator';
import Welcome from './components/solid-screens/Welcome';
import SomeCamMenu from './components/transparent-screens/SomeCamMenu';
import VowelsTest from '@/views/VowelsTest';
import VowelsTestDev from '@/views/VowelsTestDev';
import LevelsSelection from '@/views/LevelsSelection';
import BeltsSelection from '@/views/BeltsSelection';
import GameUi from '@/views/GameUi';
import Intro from '@/views/Intro';
import AnimationGenerator from '@/views/AnimationGenerator';
import Tutorial from '@/views/Tutorial';

Vue.use(Router);

export default new Router({
  mode: 'history',
  base: process.env.BASE_URL,
  routes: [
    {
      path: '/',
      component: CamLayoutMediator,
      children: [
        {
          path: '/',
          component: Welcome
        },
        {
          path: '/some-cam-menu',
          component: SomeCamMenu
        },
        {
          path: '/vowels-test',
          component: VowelsTest
        },
        {
          path: '/vowels-test-dev',
          component: VowelsTestDev
        },
        {
          path: '/belts-selection',
          name: 'BeltsSelection',
          component: BeltsSelection
        },
        {
          path: '/belts-selection/:beltColor',
          name: 'BeltsSelectionUnlocking',
          component: BeltsSelection
        },
        {
          path: '/levels-selection/:beltColor',
          name: 'LevelsSelection',
          component: LevelsSelection
        },
        {
          path: '/game/:beltColor/:level',
          name: 'GameUi',
          component: GameUi
        },
        {
          path: '/game/:beltColor/:level/:isWhiteB',
          name: 'GameUiWhiteB',
          component: GameUi
        },
        {
          path: '/intro',
          name: 'Intro',
          component: Intro
        },
        {
          path: '/animation-generator/:animation',
          name: 'AnimationGenerator',
          component: AnimationGenerator
        },
        {
          path: '/tutorial',
          name: 'Tutorial',
          component: Tutorial
        }

        // TODO: Add all routes under cam mediator here
      ]
    },
    {
      path: '/poc',
      // route level code-splitting
      // this generates a separate chunk (about.[hash].js) for this route
      // which is lazy-loaded when the route is visited.
      component: () =>
        import(/* webpackChunkName: "about" */ './views/WordsMarkPoc.vue')
    }
  ]
});
